<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import { mapActions, mapState } from 'vuex'
  import CookieOverlay from '@/components/overlays/CookieOverlay'

  export default {
    name: 'AppFooter',
    components: {
      CookieOverlay,
    },
    data: () => ({
      offsetBottom: 0,
      scrollTimer: null,
      resizeTimer: null,
      show_cookie_layer: false,
    }),
    computed: {
      ...mapState('pages', [ 'legal_pages' ]),
      ...mapState('auth', ['settings']),
      isMeta() {
        return document.querySelector('body.page_login, body.page_reset_password, body.page_forgot_password')
      },
      chatFab() {
        return document.querySelector('.chat-fab')
      },
    },
    created() {
      window.addEventListener('scroll', this.onScroll)
      window.addEventListener('resize', this.onResize)
    },
    mounted() {
      // get footer links from legal_pages API
      this.getLegalPages().then(_ => {
        this.onResize()
        this.onScroll()
      })
    },
    destroyed() {
      window.removeEventListener('scroll', this.onScroll)
      window.removeEventListener('resize', this.onResize)
    },
    methods: {
      ...mapActions('pages', [ 'getLegalPages' ]),
      onResize() {
        const isMeta = this.isMeta
        const chatFab = this.chatFab
        if (isMeta) {
          clearTimeout(this.resizeTimer)
          this.resizeTimer = setTimeout(() => {
            isMeta.style.marginBottom = null
            const contentBottom = document.querySelector('main.v-main div.container').getBoundingClientRect().bottom
            const footerTop = this.$refs.appFooter.$el.getBoundingClientRect().top
            const footerHeight = this.$refs.appFooter.$el.clientHeight
            const margin = contentBottom >= footerTop + 15 ? footerHeight + 15 : 0
            isMeta.style.marginBottom = `${margin}px`
            if (chatFab) {
              chatFab.style.marginBottom = `${footerHeight}px`
            }
          }, 250)
        }
      },
      onScroll() {
        const isMeta = this.isMeta
        const chatFab = this.chatFab
        if (chatFab && !isMeta) {
          clearTimeout(this.scrollTimer)
          this.scrollTimer = setTimeout(() => {
            const footerOffsetTop = this.$refs.appFooter.$el.offsetTop
            const scrollPosition = window.innerHeight + window.pageYOffset

            this.offsetBottom = scrollPosition > footerOffsetTop
              ? scrollPosition - footerOffsetTop
              : this.offsetBottom = 0

            chatFab.style.marginBottom = `${this.offsetBottom}px`
          }, 250)
        }
      },
    },
  }
</script>
